<template>
    <v-card style="height: 90vh">
        <v-card-title>
            <span class="toolbar_title">Create New ORT Report</span>
            <v-spacer></v-spacer>
            <v-btn icon @click="$emit('close')">
                <v-icon color="black">mdi-close</v-icon>
            </v-btn>
        </v-card-title>
        <v-tabs v-model="selected_tab" class="px-6">
            <v-tab>Info</v-tab>
        </v-tabs>
        <v-tabs-items v-model="selected_tab">
            <v-tab-item style="height: 73vh; overflow-y: auto;">
                <v-row class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 px-6 pt-6">
                        <v-text-field
                            label="Report Name"
                            :rules="report_name_rules"
                            v-model="new_report_name"
                            hide-details="auto"
                            outlined
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-row class="ma-0 pa-0">
                            <v-col cols="6">
                                <DateRange
                                    :start_date="report_start_date"
                                    :end_date="report_end_date"
                                    :min_start_date="report_min_start_date"
                                    :max_end_date="report_max_end_date"
                                    v-on:date_update="update_report_date"
                                />
                            </v-col>
                            <v-col cols="6">
                                <!-- <v-card outlined class="ort-create-section-card">
                                    <v-card-title class="pb-2">
                                        <div>
                                            <div class="scheduler_title">Pivot Variables</div>
                                            <div class="scheduler_subtitle">Choose report data levels</div>
                                        </div>
                                    </v-card-title>
                                    <v-card-text class="pt-0"> -->
                                        <v-combobox
                                            v-model="selected_pivot_variables"
                                            :items="available_pivot_variables"
                                            label="Levels"
                                            multiple
                                            chips
                                            outlined
                                            hide-details="auto"
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                    :key="JSON.stringify(data.item)"
                                                    v-bind="data.attrs"
                                                    :input-value="data.selected"
                                                    :disabled="data.disabled"
                                                >
                                                    <v-avatar
                                                        class="black white--text"
                                                        left
                                                        v-text="data.index + 1 "
                                                    ></v-avatar>
                                                    {{ data.item }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    <!-- </v-card-text>
                                </v-card> -->
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="ma-0 px-6">
                        <v-card outlined class="ort-create-section-card">
                            <v-card-title class="pb-2">
                                <div>
                                    <div class="scheduler_title">Filters</div>
                                    <div class="scheduler_subtitle">Refine your Report Output</div>
                                </div>
                            </v-card-title>
                            <v-card-text class="pt-0">
                                <v-row class="ma-0 pa-0">
                                    <v-col cols="12" sm="6">
                                        <v-select multiple label="Audience" :items="available_audiences" v-model="selected_audiences" :loading="loading_new_filters" :disabled="loading_new_filters || available_audiences.length <= 1" outlined hide-details="auto">
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index === 0"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 1"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 2"><span class="actionText">{{ item }}</span></v-chip>
                                                <span v-if="index === 3" class="grey--text text-caption">(+{{ selected_audiences.length - 3 }} others)</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-select multiple label="Region" :items="available_regions" v-model="selected_regions" :loading="loading_new_filters" :disabled="loading_new_filters || available_regions.length <= 1" outlined hide-details="auto">
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index === 0"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 1"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 2"><span class="actionText">{{ item }}</span></v-chip>
                                                <span v-if="index === 3" class="grey--text text-caption">(+{{ selected_regions.length - 3 }} others)</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-if="selected_pivot_variables.includes('Campaign') || true">
                                        <v-select multiple label="Campaign" :items="available_campaigns" v-model="selected_campaigns" :loading="loading_new_filters" :disabled="loading_new_filters || available_campaigns.length <= 1" outlined hide-details="auto">
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index === 0"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 1"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 2"><span class="actionText">{{ item }}</span></v-chip>
                                                <span v-if="index === 3" class="grey--text text-caption">(+{{ selected_campaigns.length - 3 }} others)</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-if="selected_pivot_variables.includes('Channel') || true">
                                        <v-select multiple label="Channel" :items="available_channels" v-model="selected_channels" :loading="loading_new_filters" :disabled="loading_new_filters || available_channels.length <= 1" outlined hide-details="auto">
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index === 0"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 1"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 2"><span class="actionText">{{ item }}</span></v-chip>
                                                <span v-if="index === 3" class="grey--text text-caption">(+{{ selected_channels.length - 3 }} others)</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-if="selected_pivot_variables.includes('Partner') || true">
                                        <v-select multiple label="Partner" :items="available_partners" v-model="selected_partners" :loading="loading_new_filters" :disabled="loading_new_filters || available_partners.length <= 1" outlined hide-details="auto">
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index === 0"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 1"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 2"><span class="actionText">{{ item }}</span></v-chip>
                                                <span v-if="index === 3" class="grey--text text-caption">(+{{ selected_partners.length - 3 }} others)</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" v-if="selected_pivot_variables.includes('Format') || true">
                                        <v-select multiple label="Format" :items="available_formats" v-model="selected_formats" :loading="loading_new_filters" :disabled="loading_new_filters || available_formats.length <= 1" outlined hide-details="auto">
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index === 0"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 1"><span class="actionText">{{ item }}</span></v-chip>
                                                <v-chip v-if="index === 2"><span class="actionText">{{ item }}</span></v-chip>
                                                <span v-if="index === 3" class="grey--text text-caption">(+{{ selected_formats.length - 3 }} others)</span>
                                            </template>
                                        </v-select>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-tab-item>
            <v-tab-item style="height: 73vh">
                <v-row class="ma-0 pa-0" style="height: 45vh"></v-row>
            </v-tab-item>
        </v-tabs-items>
        <v-row class="ma-0 pa-0" cols="12" justify="space-around">
            <v-col cols="3">
                <v-btn
                    style="width: 100%"
                    :disabled="!create_enabled || loading_new_filters"
                    outlined
                    color="black"
                    @click="publish_ort_report"
                >
                    <span class="actionBtn">Create</span>
                </v-btn>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
  import DateRange from "@/components/Utility/DateRange.vue";
  import ort_reporting_api_caller from "@/javascript/ort_reporting.js";
  import { ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE } from "@/constants/constants";
  
  export default {
    name: "ORTCreate",
    components: {
        DateRange
    },
    async mounted() {
        await this.get_ort_reports();
    },
    props: ["parent_id"],
    watch: {},
    data: () => ({
        selected_tab: 0,
        new_report_name: "",
        message_queue_payload: "rabbitmq publish test",

        report_start_date: '2023-11-01',
        report_end_date: '2023-11-05',

        report_min_start_date: '2023-11-01',
        report_max_end_date: '2025-12-30',

        report_name_rules: [
            value => !!value || 'Required.',
        ],

        available_campaigns: [],
        selected_campaigns: [],

        available_channels: [],
        selected_channels: [],

        available_partners: [],
        selected_partners: [],

        available_formats: [],
        selected_formats: [],

        available_audiences: [],
        selected_audiences: [],
        
        available_regions: [],
        selected_regions: [],

        loading_new_filters: true,
        
        available_pivot_variables: ['Campaign', 'Channel', 'Partner', 'Format'],
        selected_pivot_variables: ['Campaign', 'Channel', 'Partner', 'Format']
    }),
    computed: {
        create_enabled: function() {
            return this.new_report_name && this.report_start_date && this.report_end_date;
        },
    },
    methods: {
        update_report_date: async function(date) {
            this.report_start_date = date.length > 0 ? date[0] : ""
            this.report_end_date = date.length > 1 ? date[1] : ""
            await this.get_filter_values()
        },
        get_filter_values: async function () {
            this.loading_new_filters = true;

            let payload = {
                project_id: this.$project.get_val(),
                report_start_date: this.report_start_date,
                report_end_date: this.report_end_date,
            };

            let token = await this.$auth.getTokenSilently();
            
            let result = await ort_reporting_api_caller.get_filters(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });
            if (result) {
                this.available_campaigns = result['campaign_names'];
                this.available_channels = result['channels'];
                this.available_partners = result['partners'];
                this.available_formats = result['formats'];
                this.available_audiences = result['audiences'];
                this.available_regions = result['regions'];
            } else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }
            this.loading_new_filters = false;
        },
        get_ort_reports: async function () {
            this.loading_new_filters = true;

            let payload = {
                project_id: this.$project.get_val(),
            };

            let token = await this.$auth.getTokenSilently();
            
            let result = await ort_reporting_api_caller.get_reports(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });
            if (result && result["ort_reports"]) {
               this.report_min_start_date = result["min_date"];
                this.report_max_end_date = result["max_date"];
                this.report_start_date = result["min_date"];
                this.report_end_date = result["max_date"];

                this.available_campaigns = result['campaign_names'];
                this.selected_campaigns = result['campaign_names'];

                this.available_channels = result['channels'];
                this.selected_channels = result['channels'];

                this.available_partners = result['partners'];
                this.selected_partners = result['partners'];

                this.available_formats = result['formats'];
                this.selected_formats = result['formats'];

                this.available_audiences = result['audiences'];
                this.selected_audiences = result['audiences'];

                this.available_regions = result['regions'];
                this.selected_regions = result['regions'];

            } else {
                this.$emit("triggerAlert", ALERT_TYPE_ERROR, ALERT_GENERIC_MESSAGE);
            }

            this.loading_new_filters = false;
        },
        publish_ort_report: async function () {
            let lvls = [...this.selected_pivot_variables]
            lvls.unshift("Audiences")
            let payload = {
                project_id: this.$project.get_val(),
                parent_id: this.parent_id,

                report_name: this.new_report_name,
                report_start_date: this.report_start_date,
                report_end_date: this.report_end_date,
                queue_payload: this.message_queue_payload,

                data_lvls: lvls,

                audiences: this.selected_audiences,
                campaigns: this.selected_campaigns,
                channels: this.selected_channels,
                partners: this.selected_partners,
                formats: this.selected_formats,
                regions: this.selected_regions
            };

            let token = await this.$auth.getTokenSilently();
            let result = await ort_reporting_api_caller.publish_report(token, payload)
                .then((resp) => {
                    if (resp["success"]) {
                        return resp["data"];
                    }
                    return false;
                })
                .catch((e) => {
                    console.log("error", e);
                    return false;
                });
            this.$emit("report_published", !!result);
            this.new_report_name = "";
            this.selected_pivot_variables = this.available_pivot_variables;
        },
    },
  };
  </script>
  
  <style scoped>
    .ort-create-section-card {
      border-radius: 12px;
      max-height: calc(73vh - 24px - 24px - 80px);
      overflow-y: auto;
    }

    .scheduler_title {
      font-size: 1rem;
      font-weight: 600;
    }

    .scheduler_subtitle {
      color: rgba(0, 0, 0, 0.6);
      font-size: 0.85rem;
      line-height: 1.4;
    }

    .dialogTitle {
      font-family: "Poppins";
      font-weight: 600 !important;
      font-size: 1.2em !important;
    }
    .actionText {
      font-family: "Poppins";
      font-weight: 400 !important;
      font-size: 0.9em !important;
    }
    .filterSectionTitle{
        font-family: "Poppins";
        text-decoration: underline;
        font-weight: 600 !important;
        font-size: 1.1em !important;
    }
  </style>
  
  
